import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199ccc5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image__preview" }
const _hoisted_2 = { class: "image-slot" }
const _hoisted_3 = { class: "image__preview" }
const _hoisted_4 = { class: "image-slot" }
const _hoisted_5 = { class: "btn-action" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ItemSKUList = _resolveComponent("ItemSKUList")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.state.isShowAddSku,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.isShowAddSku) = $event)),
    title: "Add SKU",
    width: "42%",
    top: "2vh",
    onClose: _ctx.cancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formAddSku",
        model: _ctx.state.orderItem,
        "label-width": "100px",
        width: "100%",
        rules: _ctx.formRules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Catalog",
            prop: "catalogId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.state.orderItem.catalogId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.orderItem.catalogId) = $event)),
                placeholder: "Select Catalog",
                style: {"width":"60%"},
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                "default-first-option": "",
                "remote-method": _ctx.getCatalog
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalogs, (catalog) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: catalog._id,
                      label: catalog.name,
                      value: catalog._id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Product",
            prop: "productId",
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.state.orderItem.productId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.orderItem.productId) = $event)),
                style: {"width":"60%"},
                placeholder: "Select Product",
                onChange: _ctx.onChangeProduct,
                remote: "",
                "default-first-option": "",
                "reserve-keyword": "",
                "remote-method": _ctx.getProducts,
                filterable: "",
                disabled: _ctx.state.isSubmitedSku === _ctx.orderProductService.ACTION.UPDATE
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.products, (product) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: product._id,
                      label: product.title,
                      value: product._id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange", "remote-method", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Design",
                prop: "artwork1",
                style: {"width":"40%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_el_image, {
                      src: _ctx.imageUrl(_ctx.state.product.artwork1),
                      fit: "cover",
                      style: {"width":"200px","height":"200px"}
                    }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_icon_picture)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["src"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Preview",
                prop: "artwork2",
                style: {"width":"40%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_image, {
                      src: _ctx.imageUrl(_ctx.state.product.artwork2),
                      fit: "cover",
                      style: {"width":"200px","height":"200px"}
                    }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_icon_picture)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["src"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_ItemSKUList),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.onSubmit }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}